import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterDataRecords, HistoryMedical, NoteAdd, Record, RecordCreate, VetTimeSlots } from '../../models';
import { environment } from '../../../environments/environment';
import { StatusRecord } from '../../consts';

@Injectable({
  providedIn: 'root'
})
export class RecordService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll(date: string, dateTo?: string, filterData?: FilterDataRecords) {
    let queries = '?booking_time_from=' + date + '&booking_time_to=' + (dateTo || date);

    if (filterData) {
      let serviceIds: Array<string> = [];
      filterData.services.forEach((service) => {
        if (service.selected) {
          serviceIds.push(service.id.toString());
        }
      });

      let vetIds: Array<string> = [];
      filterData.vets.forEach((vet) => {
        if (vet.selected) {
          vetIds.push(vet.id.toString());
        }
      });
      queries = queries + '&ordering=' + filterData.sortField + '&statuses=' + filterData.statuses.join(',') + '&service_types=' + serviceIds.join(',') + '&specialist_ids=' + vetIds.join(',') + '&live_queue='+filterData.live_queue;
    }

    console.log('queries', queries);

    return this.http.get<{
      code: string;
      data: Array<Record>
    }>(`${environment.host}/booking/${queries}`);
  }

  public getAvailableDays(data: {
    date?: string,
    service_id: number,
    year?: number,
    orgId: number,
    month?: number,
    specialist_id?: number
  }) {
    // let queries = '?service_id=' + data.service_id  + '&month=' + data.month + '&year=' + (data.year || '') + '&date=' + (data.date || '');
    let queries = `?service_id=${data.service_id}&specialist_id=${data.specialist_id || ''}&month=${data.month}&year=${data.year || ''}&date=${data.date || ''}`
    return this.http.get<{
      code: string;
      data: {
        available_days: Array<string>
      }
    }>(`${environment.host}/booking/${data.orgId}/available_days${queries}`);
  }

  public getMedicalHistories(petId: number) {
    return this.http.get<{
      code: string;
      data: Array<HistoryMedical>
    }>(`${environment.host}/booking/pet_history/${petId}`);
  }

  public getFileLinkDownload(noteId: number) {
    return this.http.get<{
      code: string;
      data: {
        file_url: string;
      }
    }>(`${environment.host}/note/${noteId}/download/`);
  }

  public getBookingInfo(bookingId: number) {
    return this.http.get<{
      code: string;
      data: Record
    }>(`${environment.host}/booking/note_info/${bookingId}`);
  }

  public getTimesVets(date: string, vetId: number, serviceId: number) {
    return this.http.get<{
      code: string;
      data: Array<{
        date: string,
        time_slots: Array<Array<string>>
      }>
    }>(`${environment.host}/booking/${vetId}/date_by_spec/?date=${date}&service_id=${serviceId}`);
  }

  public getTimesSlotByDate(date: string, serviceId: number) {
    return this.http.get<{
      code: string;
      data: Array<VetTimeSlots>
    }>(`${environment.host}/booking/spec_by_date/?date=${date}&service_id=${serviceId}`);
  }

  public getMeetingLink(bookingId: number) {
    return this.http.get<{
      code: string;
      data: {
        meet_url: string
      }
    }>(`${environment.host}/booking/meet/${bookingId}`);
  }

  public create(data: RecordCreate) {
    return this.http.post<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/booking/create/`, data);
  }

  public updateStatus(id: number, status: StatusRecord) {
    return this.http.put<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/booking/${id}/change_status`, {
      status
    });
  }

  public updateAmount(amount: number, id: number) {
    return this.http.put<{
      code: string;
      data: any,
      message: string
    }>(`${environment.host}/booking/${id}/update`, {
      amount
    });
  }
}
